module.exports = __webpack_public_path__ + "static/media/joystick.69108d28.svg";